
import { useTranslation } from 'react-i18next';

export default function StatsSection() {
  const { t } = useTranslation();

  const stats = [
    { labelKey: 'stats.s1.label', valueKey: 'stats.s1.value', descKey: 'stats.s1.desc', icon: 'ri-user-line' },
    { labelKey: 'stats.s2.label', valueKey: 'stats.s2.value', descKey: 'stats.s2.desc', icon: 'ri-image-line' },
    { labelKey: 'stats.s3.label', valueKey: 'stats.s3.value', descKey: 'stats.s3.desc', icon: 'ri-star-fill' },
  ];

  return (
    <section className="py-24 lg:py-40 bg-[#1e2025]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl lg:text-6xl font-display font-black text-white mb-8">
            {t('stats.title')}
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto font-semibold">
            {t('stats.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#252830] border-2 border-gray-700 shadow-lg mb-8">
                <i className={`${stat.icon} text-4xl text-primary`}></i>
              </div>
              <div className="mb-3">
                <span className="text-base font-black uppercase tracking-widest text-gray-500">
                  {t(stat.labelKey)}
                </span>
              </div>
              <div className="text-7xl lg:text-8xl font-black text-primary mb-4 font-display">
                {t(stat.valueKey)}
              </div>
              <p className="text-lg text-gray-400 font-bold">
                {t(stat.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
